<template>
  <v-card>
    <v-toolbar :color="$store.getters.toolbarColor" dark>
      <v-toolbar-title>Forget Password</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <message :messages="messages"></message>
      <form>
        <v-text-field v-model="forgetPwForm.email" :label="labels.email" type="email" :error-messages="errors.collect('forgetPwForm.email')" v-validate="'required|email'" data-vv-name="forgetPwForm.email" :data-vv-as="labels.email"></v-text-field>
        <v-btn color="primary" type="submit" @click.prevent="doForget" :loading="loading">Retrieve Password</v-btn>
        <v-btn flat :to="{ name: 'login'}">Cancel</v-btn>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      labels: {
        email: 'Email*'
      },
      forgetPwForm: {
        email: ''
      },
      loading: false
    }
  },
  methods: {
    async doForget() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.resetMessages()
          const apiURI = this.$store.state.app.baseMenu.forgetPassword
          if (apiURI) {
            this.loading = true
            this.$http.post(apiURI, this.forgetPwForm)
              .then(response => {
                const { data } = response
                this.message(data)
                this.loading = false
              })
              .catch((error) => {
                const { data } = error.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
                this.loading = false
              })
          } else {
            this.errorMessage('Invalid API URL')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  mixins: [
    MessageMixin
  ]
}
</script>

<style lang="scss">

</style>
